import React from 'react'
import { Layout, Menu, PageHeader, Tooltip } from 'antd'
import { useHistory } from 'react-router-dom'
import { useWindowDimensions } from '../../hooks'
import {
	CompassOutlined,
	ArrowRightOutlined,
	ArrowLeftOutlined,
} from '@ant-design/icons'

const AppLayout: React.FC = ({ children }) => {
	const history = useHistory()
	const { x } = useWindowDimensions()
	return (
		<Layout>
			<Layout.Sider
				theme='dark'
				collapsible
				collapsed={true}
				className='site-layout-background'
				width={200}
				trigger={null}
				style={{
					position: 'fixed',
					height: '100%',
				}}
			>
				<Menu
					mode='inline'
					defaultSelectedKeys={['1']}
					triggerSubMenuAction='click'
					style={{
						height: '100%',
						backgroundColor: '#f9f9f9',
						borderRadius: '5px',
					}}
				>
					<Menu.SubMenu
						key='1'
						title='Explorar'
						icon={
							<Tooltip title='Explorar' placement='right'>
								<CompassOutlined
									style={{ fontSize: '1.25rem', color: '#333' }}
								/>
							</Tooltip>
						}
					>
						<Menu.Item
							key='1.1'
							onClick={() => {
								history.push('/gastos')
							}}
						>
							<>
								Gastos <ArrowRightOutlined style={{ fontSize: '1rem' }} />
							</>
						</Menu.Item>
						<Menu.Item
							key='1.2'
							onClick={() => {
								history.push('/ingresos')
							}}
						>
							<>
								Ingresos <ArrowLeftOutlined style={{ fontSize: '1rem' }} />
							</>
						</Menu.Item>
					</Menu.SubMenu>
				</Menu>
			</Layout.Sider>

			<Layout.Content
				style={{
					minHeight: '100vh',
					paddingLeft: '5rem',
					paddingRight: '2rem',
				}}
			>
				<PageHeader
					style={{ marginLeft: '1rem' }}
					title={
						x > 550 ? '📈 Sistema de Transparencia Presupuestaria 💰' : 'STP 💰'
					}
				/>
				{children}
			</Layout.Content>
		</Layout>
	)
}

export default AppLayout
